export const DEFAULT_PROJECT_DETAILS_WIZARD_TITLE = "Project details";
